import Icon from "./Icon.jsx";

export default function PageIntro({ eyebrow, title, description, icon = "chart" }) {
  return (
    <header className="page-intro">
      <div className="page-intro-copy">
        <p className="eyebrow">{eyebrow}</p>
        <h1>{title}</h1>
        <p className="page-intro-description">{description}</p>
      </div>
      <div className="page-intro-art" aria-hidden="true">
        <span className="intro-orbit" />
        <span className="intro-orbit inner" />
        <span className="intro-icon"><Icon name={icon} size={38} strokeWidth={1.4} /></span>
        <span className="intro-dot" />
      </div>
    </header>
  );
}
